import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';


@Injectable()
export class StpService {

//   usuario: Usuario;
  token: string;
//   usuario2: Usuario2;
  idUsuario: string;
  options: any[] = [];
  constructor(
    public http: HttpClient,
    public router: Router
  ) {

  }


  getStpAccountBalanceStp(params) {

    const url = `${environment.URL_SERVICIOS}/consultaSaldoCuenta?business=${params.empresa}&ordering_account=${params.cuentaOrdenante}`;
    return this.http.post(url, {})

  }

  getContributorsWithStpAccounts() {

    const url = `${environment.URL_SERVICIOS}/get_contributors_with_stp_accounts`;
    return this.http.get(url)

  }

  generateAccountStp() {

    const url = `${environment.URL_SERVICIOS}/generate_stp_account`;
    return this.http.get(url)

  }

  registraOrdenPago( params ) {
  
    const url = `${environment.URL_SERVICIOS}/registraOrden`;
  
    return this.http.post( url, params ).pipe(
      map( (resp: any) => {
        return resp;
      }));
  
  }

  conciliacion( params ) {
  
    const url = `${environment.URL_SERVICIOS}/conciliacion`;
  
    return this.http.post( url, params ).pipe(
      map( (resp: any) => {
        return resp;
      }));
  
  }

  createStpAccount(params) {
    const url = `${environment.URL_SERVICIOS}/create_stp_account?contributor_id=${params.contributor_id}&cuenta_clabe=${params.cuenta_clabe}&cuenta_concentradora=${params.cuenta_concentradora}`;
    return this.http.post(url, {})

  }


}
